module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lijstofdetail),
      expression: "lijstofdetail"
    }],
    staticStyle: {
      "position": "fixed"
    },
    attrs: {
      "dense": ""
    }
  }, [_c('v-btn', {
    staticClass: "green white--text",
    staticStyle: {
      "margin": "0px",
      "margin-left": "10px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.NieuweWerfClick($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue white--text",
    staticStyle: {
      "margin": "0px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.afdrukkenClicked($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("print")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lijstofdetail),
      expression: "lijstofdetail"
    }],
    staticClass: "topclass"
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "position": "fixed",
      "margin-top": "46px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "60px",
      "margin": "0px",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "werfnrcol th"
  }, [_c('v-text-field', {
    staticClass: "textfieldcell",
    attrs: {
      "label": "",
      "prepend-icon": "filter_list"
    },
    on: {
      "input": _vm.updateFilters
    },
    model: {
      value: (_vm.werfnrfilter),
      callback: function($$v) {
        _vm.werfnrfilter = $$v
      },
      expression: "werfnrfilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "naamcol th"
  }, [_c('v-text-field', {
    staticClass: "textfieldcell",
    attrs: {
      "label": "",
      "prepend-icon": "search"
    },
    on: {
      "input": _vm.updateFilters
    },
    model: {
      value: (_vm.naamfilter),
      callback: function($$v) {
        _vm.naamfilter = $$v
      },
      expression: "naamfilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "machcol th"
  })]), _vm._v(" "), _c('div', {})]), _vm._v(" "), _c('div', {
    staticClass: "table",
    staticStyle: {
      "padding-top": "148px"
    }
  }, _vm._l((_vm.werven), function(entry) {
    return _c('div', {
      staticClass: "tr",
      on: {
        "click": function($event) {
          return _vm.clicked(entry)
        }
      }
    }, [_c('div', {
      staticClass: "werfnrcol td"
    }, [_vm._v(_vm._s(entry.werfnr))]), _c('div', {
      staticClass: "naamcol td",
      staticStyle: {
        "text-overflow": "ellipsis"
      }
    }, [_vm._v(_vm._s(entry.werfnaam))]), _c('div', {
      staticClass: "machcol td"
    }, [_vm._v(_vm._s(entry.aantalMachines))])])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.lijstofdetail),
      expression: "!lijstofdetail"
    }],
    staticClass: "topclass"
  }, [_c('wervendetail', {
    on: {
      "backWerven": _vm.backWerven
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "400px",
      "persistent": ""
    },
    model: {
      value: (_vm.showNewWerfDialog),
      callback: function($$v) {
        _vm.showNewWerfDialog = $$v
      },
      expression: "showNewWerfDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Werf Toevoegen")])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "werfnummer",
      "required": ""
    },
    model: {
      value: (_vm.nieuwWerfVolgnr),
      callback: function($$v) {
        _vm.nieuwWerfVolgnr = $$v
      },
      expression: "nieuwWerfVolgnr"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "naam",
      "required": ""
    },
    model: {
      value: (_vm.nieuweWerfOmschr),
      callback: function($$v) {
        _vm.nieuweWerfOmschr = $$v
      },
      expression: "nieuweWerfOmschr"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "red--text"
  }, [_vm._v(_vm._s(_vm.TError))])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "blue--text darken-1",
    nativeOn: {
      "click": function($event) {
        _vm.showNewWerfDialog = false
      }
    }
  }, [_vm._v("Sluiten")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    nativeOn: {
      "click": function($event) {
        return _vm.nieuweWerfSaveClick($event)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "40px",
      "margin": "0px",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "werfnrcol th"
  }, [_vm._v("WERFNR")]), _vm._v(" "), _c('div', {
    staticClass: "naamcol th"
  }, [_vm._v("NAAM")]), _vm._v(" "), _c('div', {
    staticClass: "machcol th",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_vm._v("AANTAL MACHINES")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4dd59f68"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/werven.vue
// module id = 44
// module chunks = 3